export default __webpack_public_path__ + "static/media/What-we-do-Landing page-Branding & Graphic Design.ad4a94b5.png";